var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVdIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#2C2C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.666 24.833C40.666 28.7036 38.9525 32.1739 36.2426 34.5268L34.0548 37.2008L29.4156 43.2318C28.6499 44.2271 27.1526 44.2375 26.3732 43.253L19.5526 34.6375C16.7681 32.2835 15 28.7647 15 24.833C15 17.7455 20.7455 12 27.833 12C34.9205 12 40.666 17.7455 40.666 24.833ZM27.8319 34.4425C33.1386 34.4425 37.4405 30.1406 37.4405 24.8339C37.4405 19.5272 33.1386 15.2253 27.8319 15.2253C22.5252 15.2253 18.2232 19.5272 18.2232 24.8339C18.2232 30.1406 22.5252 34.4425 27.8319 34.4425Z",
    fill: "#36B789"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4202 17.4216C28.3525 16.4611 31.0039 17.4232 32.2059 18.2442C32.3769 18.361 32.2985 18.6053 32.0933 18.6335C26.8664 19.3529 26.9428 23.2866 25.9386 22.9519C25.1091 22.6754 25.2473 19.1498 25.4202 17.4216Z",
    fill: "#86FFD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2442 20.0449C36.1376 22.4813 36.1262 25.3018 35.7588 26.7103C35.7065 26.9108 35.4501 26.9193 35.3543 26.7357C32.914 22.0578 29.2366 23.4566 29.213 22.3984C29.1935 21.5242 32.559 20.4651 34.2442 20.0449Z",
    fill: "#86FFD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3782 29.253C32.7022 31.8438 30.0356 32.7629 28.5848 32.8804C28.3783 32.8971 28.2857 32.6578 28.4275 32.5069C32.0393 28.6608 29.5063 25.6501 30.4976 25.2789C31.3165 24.9723 33.4259 27.8005 34.3782 29.253Z",
    fill: "#86FFD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6511 32.3815C22.6993 31.4824 21.0825 29.1713 20.5707 27.8086C20.4978 27.6147 20.7024 27.4599 20.8865 27.5547C25.5774 29.9699 27.7756 26.7068 28.405 27.5579C28.925 28.2609 26.7857 31.0666 25.6511 32.3815Z",
    fill: "#86FFD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.18 24.6103C20.2917 21.5266 22.1106 19.3709 23.2963 18.5266C23.465 18.4064 23.6671 18.5644 23.6227 18.7667C22.492 23.9203 26.2099 25.2076 25.5489 26.0343C25.0028 26.7172 21.7421 25.3695 20.18 24.6103Z",
    fill: "#86FFD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdIcon);
export default __webpack_public_path__ + "static/media/vdIcon.7e9417d7124eee8fcf7f415f7ace1bbe.svg";
export { ForwardRef as ReactComponent };